import type { LucideIcon } from 'lucide-react';

// Titulo de bloco de formulario (Identificacao / Contato / Endereco / ...).
// Use dentro de um container .form-grid — ocupa a linha inteira.
// Cores 100% via tokens do tema: o acento sai azul no Azul Royal, cobre no Cobre, etc.
// Peca unica reusada por todos os cadastros (clientes, fornecedores, usuarios...).
export function SecaoForm({ icone: Icone, titulo, primeira }: { icone: LucideIcon; titulo: string; primeira?: boolean }) {
  return (
    <div
      data-componente="004"
      style={{
        gridColumn: '1 / -1',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginTop: primeira ? 0 : 20,
        marginBottom: 2,
        paddingBottom: 7,
        borderBottom: '1px solid var(--panel-border, #e5e7eb)',
        color: 'var(--primary, #2563eb)',
        fontFamily: 'var(--font-display, inherit)',
        fontWeight: 600,
        fontSize: 12.5,
        letterSpacing: 0.5,
        textTransform: 'uppercase',
      }}
    >
      <Icone size={15} strokeWidth={2.25} />
      {titulo}
    </div>
  );
}
